// import React from 'react';

// const DevOpsSection = () => {

//   const stats = [
//     {
//       value: '95',
//       symbol: '%',
//       // label: 'Improvement in deployment frequency. Faster releases, quicker feedback, and better product iterations.',
//       label: 'Improved deployment frequency'    
//     },
//     {
//       value: '40',
//       symbol: '%',
//       // label: "Reduction in lead time for changes with automated CI/CD pipelines and optimized workflows with RogerOps' expertise.",
//       label: 'Reduction in lead time'
//     },
//     {
//       value: '1000',
//       symbol: '+',
//       // label: 'Increased system uptime and reliability with automated monitoring and proactive issue resolution strategies.',
//       label: 'Projects delievered'
//     },
//     {
//       value: '60',
//       symbol: '%',
//       // label: 'Cost reduction through infrastructure automation and resource optimization.',
//       label: 'Cost reduction'   
//     },
//     {
//       value: '99.9',
//       symbol: '%',
//       // label: 'Uptime & deployment stability — reducing downtime and failures drastically.',
//       label: 'Uptime & Deployment stability'
//     },
//     {
//       value: '70',
//       symbol: '%',
//       // label: 'Improved infrastructure security with proactive monitoring and vulnerability patching.',
//       label: 'Improved Security'
//     },
//     {
//       value: '0',
//       symbol: '%',
//       // label: 'Zero major security breaches in systems managed under RogerOps',
//       label: 'Zero Security Breaches'
//     },

//   ];
  

//   return (
//     <section className="py-16 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//           <div>
//             <h2 className="text-4xl font-bold text-gray-900 mb-6">
//               Empowering <span className="italic">DevOps Excellence</span> <br />
//               with Partnership and Precision <br />
//             </h2>
//             <h3 className='text-xl font-semibold text-[#3498db] mb-6'>
//               Accelerate Delivery. Strengthen Systems. Scale Seamlessly.

//             </h3>
//             <p className="text-lg text-gray-700 mb-5">
//             At RogerOps, we engineer high-performance DevOps frameworks 
//             while working hand-in-hand with your teams to modernize workflows, 
//             improve collaboration, and reduce friction. From CI/CD automation 
//             to cloud-native infrastructure, our solutions are built to align 
//             technology with business goals — delivering speed, reliability, 
//             and scalability where it matters most.
//             </p>
//             <p className="text text-gray-700 mb-5">
//             Together, we build a resilient DevOps culture that drives lasting results and future-ready operations.  
//             </p>

//             {/* <div className="grid grid-cols-2 gap-8">
//               {stats.map((stat, index) => (
//                 <div key={index}>
//                   <div className="text-4xl font-bold text-gray-900 mb-2">
//                     {stat.value} {stat.symbol}
//                   </div>
//                   <div className="text-gray-700">{stat.label}</div>
//                 </div>
//               ))}
//             </div>
//           </div> */}

//           {/* Scrolling stats here */}
//           <div className="overflow-hidden relative w-full mb-12">
//               <div className="flex animate-scroll gap-6 whitespace-nowrap">
//               {/* <div className="flex animate-scroll gap-6 whitespace-nowrap"> */}
//                 {stats.map((stat, index) => (
//                   <div key={index} className="min-w-[300px] flex flex-col justify-start items-start">
//                     <div className="text-4xl font-bold text-gray-900 mb-2">
//                       <span className="mr-2">{stat.value}</span>
//                       <span>{stat.symbol}</span>
//                     </div>
//                     <div className="text-gray-700  text-center max-w-xs break-words">{stat.label}</div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>


//           <div>
//             <img
//               src="/images/tenweb_media_rhknxtmyx.webp"
//               alt="Team collaborating on DevOps implementation"
//               className="w-full rounded-lg shadow-md"
//             />
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default DevOpsSection;







// import React from 'react';

// const DevOpsSection = () => {
//   const stats = [
//     {
//       value: '95',
//       symbol: '%',
//       label: 'Improved deployment frequency'    
//     },
//     {
//       value: '40',
//       symbol: '%',
//       label: 'Reduction in lead time'
//     },
//     {
//       value: '1000',
//       symbol: '+',
//       label: 'Projects delivered'
//     },
//     {
//       value: '60',
//       symbol: '%',
//       label: 'Cost reduction'   
//     },
//     {
//       value: '99.9',
//       symbol: '%',
//       label: 'Uptime & Deployment stability'
//     },
//     {
//       value: '70',
//       symbol: '%',
//       label: 'Improved Security'
//     },
//     {
//       value: '0',
//       symbol: '%',
//       label: 'Security Breaches'
//     },
//   ];
  
//   return (
//     <section className="py-16 bg-white">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
//           <div>
//             <h2 className="text-4xl font-bold text-gray-900 mb-6">
//               Empowering <span className="italic">DevOps Excellence</span> <br />
//               with Partnership and Precision <br />
//             </h2>
//             <h3 className="text-xl font-semibold text-[#3498db] mb-6">
//               Accelerate Delivery. Strengthen Systems. Scale Seamlessly.
//             </h3>
//             <p className="text-lg text-gray-700 mb-5">
//               At RogerOps, we engineer high-performance DevOps frameworks 
//               while working hand-in-hand with your teams to modernize workflows, 
//               improve collaboration, and reduce friction. From CI/CD automation 
//               to cloud-native infrastructure, our solutions are built to align 
//               technology with business goals — delivering speed, reliability, 
//               and scalability where it matters most.
//             </p>
//             <p className="text-base text-gray-700 mb-8">
//               Together, we build a resilient DevOps culture that drives lasting results and future-ready operations.  
//             </p>

//             {/* Scrolling stats container */}
//             <div className="w-full overflow-hidden relative">
//               <div className="flex gap-6 animate-scroll whitespace-nowrap">
//                 {stats.concat(stats).map((stat, index) => (
//                   <div key={index} className="inline-block min-w-[180px] flex-none">
//                     <div className="text-4xl font-bold text-gray-900 mb-2">
//                       {stat.value}{stat.symbol}
//                     </div>
//                     <div className="text-gray-700 whitespace-normal w-[180px]">{stat.label}</div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>

//           <div>
//             <img
//               src="/images/tenweb_media_rhknxtmyx.webp"
//               alt="Team collaborating on DevOps implementation"
//               className="w-full rounded-lg shadow-md"
//             />
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default DevOpsSection;


import React from 'react';
// DevOpsSection.jsx
const DevOpsSection = () => {
  const stats = [
    {
      value: '95',
      symbol: '%',
      label: 'Improved deployment frequency',
    },
    {
      value: '40',
      symbol: '%',
      label: 'Reduction in lead time',
    },
    {
      value: '1000',
      symbol: '+',
      label: 'Projects delivered',
    },
    {
      value: '60',
      symbol: '%',
      label: 'Cost reduction',
    },
    {
      value: '99.9',
      symbol: '%',
      label: 'Uptime & Deployment stability',
    },
    {
      value: '70',
      symbol: '%',
      label: 'Improved Security',
    },
    {
      value: '0',
      symbol: '%',
      label: 'Zero Security Breaches',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className='mx-[2rem]'>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Empowering <span className="italic">DevOps Excellence</span>{' '}
              <br />
              with Partnership and Precision <br />
            </h2>
            <h3 className="text-xl font-semibold text-[#3498db] mb-6">
              Accelerate Delivery. Strengthen Systems. Scale Seamlessly.
            </h3>
            <p className="text-lg text-gray-700 mb-5">
              At RogerOps, we engineer high-performance DevOps frameworks while
              working hand-in-hand with your teams to modernize workflows,
              improve collaboration, and reduce friction. From CI/CD automation
              to cloud-native infrastructure, our solutions are built to align
              technology with business goals — delivering speed, reliability,
              and scalability where it matters most.
            </p>
            <p className="text-base text-gray-700 mb-8">
              Together, we build a resilient DevOps culture that drives lasting
              results and future-ready operations.
            </p>

            {/* Smooth scrolling stats with Tailwind classes */}
            <div className="w-full overflow-hidden relative">
              <div className="infinite-scroll-container">
                {/* First set of items */}
                <div className="flex gap-8 pr-8">
                  {stats.map((stat, index) => (
                    <div key={`set1-${index}`} className="flex-none w-[180px]">
                      <div className="text-4xl font-bold text-gray-900 mb-2">
                        {stat.value}
                        {stat.symbol}
                      </div>
                      <div className="text-gray-700 w-full">{stat.label}</div>
                    </div>
                  ))}
                </div>

                {/* Duplicate set for seamless looping */}
                <div className="flex gap-8 pr-8">
                  {stats.map((stat, index) => (
                    <div key={`set2-${index}`} className="flex-none w-[180px]">
                      <div className="text-4xl font-bold text-gray-900 mb-2">
                        {stat.value}
                        {stat.symbol}
                      </div>
                      <div className="text-gray-700 w-full">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div>
            <img
              src="/images/tenweb_media_rhknxtmyx.webp"
              alt="Team collaborating on DevOps implementation"
              className="w-full rounded-lg shadow-md"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DevOpsSection;
